import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { BYSAVE, BYTOKEN } from '../interceptors/auth-salesforce.interceptor';

@Injectable({
  providedIn: 'root',
})
export class SalesforceService {
  private http = inject(HttpClient);

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(`Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }

  saveLead(data: any) {
    return this.http
      .post<any>(environment.lead, data, {
        context: new HttpContext().set(BYSAVE, true),
      })
      .pipe(map((res) => res));
  }

  saveCase(data: any) {
    return this.http
      .post<any>(environment.case, data, {
        context: new HttpContext().set(BYSAVE, true),
      })
      .pipe(map((res) => res));
  }

  generateToken() {
    return this.http
      .get<any>(environment.getToken, {
        context: new HttpContext().set(BYTOKEN, true),
      })
      .pipe(catchError(this.handleError));
  }

  saveSuccess(data: any) {
    return this.http.post(environment.apiURL + 'salesforce/', data).pipe(map((res) => res));
  }
}
